import React from "react";
import "./Project.css";

function Project({ title, description, image, link }) {
  return (
    <div className="project">
      <div className="project-content">
        <a className="project-link" href={`${link}`}>
          <h3 className="project-title">{title}</h3>
        </a>
        <img className="project-image" src={`${image}`} alt="project"></img>
        <p className="project-description">{description}</p>
      </div>
    </div>
  );
}

export default Project;
